export default {
    control: 0,
    unitLimits:1,
    deviceLimits: 2,
    eDeviceLimits: 3
}
